import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import { BannerService } from '../../shared/services/banner.service';
import { saveAs } from 'file-saver';
import * as TyreOrderActions from './tyre-order.action';
import { TyreOrderService } from './tyre-order.service';
import { OrderService } from '../order/order.service';
import * as TyreOrderModels from '../../models/tyre-order/tyre-order';
import * as OrderStatusModels from '../../models/order/orderStatus';
import { TyreOrderSearchModel } from '../../models/tyre-order/tyre-orderSearch';

import { HelperService } from '../../../../src/app/services/helper/helper.service';
import { empty } from 'rxjs';
import { SaveState } from '../../models/commonModels';
import { StorageService } from '../../shared/services/storage.service';


import {
  HttpInterceptor,
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpHeaders
} from '@angular/common/http';



export interface TyreOrderStateModel {
    OrderStatus: OrderStatusModels.OrderStatusListModel;
    OrderList: TyreOrderModels.TyreOrderListModel;
    Order: TyreOrderModels.TyreOrderObjectModel;
    Search: TyreOrderSearchModel;
    ImportStatus: any;
    FilteredReportLoading: number;
    ImportLatexStatus: number;
  }

class DictionaryKeys {
  public static readonly OrderStatus = "TyreOrderOrderStatus";
}


@State<TyreOrderStateModel>({
    name: 'tyreOrderState',
    defaults: {
      OrderStatus: null,
      OrderList: null,
      Search: null,
      Order: null,
      ImportStatus: false,
      FilteredReportLoading: null,
      ImportLatexStatus: null
    }
  })

  @Injectable()

  export class TyreOrderState {

    constructor(
      private helperService: HelperService,
      private orderService: OrderService,
      private tyreOrderService: TyreOrderService,
      private bannerService: BannerService,
      private storageService: StorageService

  ) { }

  @Selector()
  static FilteredReportLoading(state: TyreOrderStateModel) {
    return state.FilteredReportLoading;
  }

  @Selector()
  static OrderStatus(state: TyreOrderStateModel) {
    return state.OrderStatus;
  }

  @Selector()
  static OrderList(state: TyreOrderStateModel) {
    return state.OrderList;
  }

  @Selector()
  static Order(state: TyreOrderStateModel) {
    return state.Order;
  }

  @Selector()
  static OrderSearch(state: TyreOrderStateModel) {
    return state.Search;
  }

  @Selector()
  static ImportStatus(state: TyreOrderStateModel) {
    return state.ImportStatus;
  }

  @Selector()
  static ImportLatexStatus(state: TyreOrderStateModel) {
    return state.ImportLatexStatus;
  }


  @Action(TyreOrderActions.GetList)
  GetList(
    context: StateContext<TyreOrderStateModel>,
    action: TyreOrderActions.GetList
  ) {

    const errorMessage = 'Błąd pobierania listy zleceń zamówienia opon.';

    context.setState(
      patch({
        OrderList: null
      })
    );

    this.tyreOrderService.getList(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            OrderList: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('OrderActions.GetList', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(TyreOrderActions.SetSearch)
  SetSearch(
    context: StateContext<TyreOrderStateModel>,
    action: TyreOrderActions.SetSearch
  ) {

    action.Search.CurrentPage = 1;

    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new TyreOrderActions.GetList(action.Search));
  }

  @Action(TyreOrderActions.SetListPage)
  SetListPage(
    context: StateContext<TyreOrderStateModel>,
    action: TyreOrderActions.SetListPage
  ) {

    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new TyreOrderActions.GetList(action.Search));
  }

  @Action(TyreOrderActions.ResetSearch)
  ResetSearch(
    context: StateContext<TyreOrderStateModel>
  ) {

    const state = context.getState();

    const search = new TyreOrderSearchModel();

    search.ItemsPerPage = state.Search.ItemsPerPage;

    context.setState(
      patch({
        Search: search
      }));

    context.dispatch(new TyreOrderActions.GetList(search));
  }

  @Action(TyreOrderActions.GetStatusDictionary)
  GetStatusDictionary(
    context: StateContext<TyreOrderStateModel>
  ) {

    const errorMessage = 'Błąd pobierania statusów zleceń zamawiania opon.';

    let storageKey = DictionaryKeys.OrderStatus;

    context.setState(
      patch({
        OrderStatus: this.storageService.getItemJSON(storageKey)
      })
    );


    const state = context.getState();

    if (!state.OrderStatus) {
      this.tyreOrderService.getStatusDictionary().subscribe((ret) => {
        if (ret.Success) {

          context.setState(
            patch({
              OrderStatus: ret
            })
          );

          this.storageService.setItemJSON(storageKey, ret);

        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
        (error) => {
          this.helperService.SaveException('TyreOrderActions.GetStatusDictionary', error);

          this.bannerService.error(errorMessage);
        });
    }
  }

  @Action(TyreOrderActions.Create)
  Create(
    context: StateContext<TyreOrderStateModel>,
    action: TyreOrderActions.Create
  ) {
    const errorMessage = 'Błąd utworzenia nowego zlecenia zamówienia opon.';

    this.tyreOrderService.create(action.Order).subscribe(
      ret => {

        if (ret.Success) {

          this.bannerService.success('Utworzono nowe zlecenie ' + ret.Item.Number + '.');

          if (ret.Message && ret.Message.length > 0)
          {
            this.bannerService.info(ret.Message);
          }
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }

        context.setState(
          patch({
            Order: ret
          })
        );
      },

      (error) => {

        this.helperService.SaveException('TyreOrderActions.Create', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  // this action state is responsible for clear the upload form
  @Action(TyreOrderActions.SetImportStatus)
  SetImportStatus(
    context: StateContext<TyreOrderStateModel>,
    action: TyreOrderActions.SetImportStatus
  ) {
    context.setState(
      patch({
        ImportStatus: action.Status
      })
    );
  }

  @Action(TyreOrderActions.Import)
  Import(
    context: StateContext<TyreOrderStateModel>,
    action: TyreOrderActions.Import
  ) {

    this.bannerService.quickInfo('Rozpoczęto import zleceń zamówień opon, proszę czekać.');

    context.dispatch(new TyreOrderActions.SetImportStatus(true));

    this.tyreOrderService.uploadFile(action.Data).subscribe(ret => {

      this.helperService.consoleLog(ret.headers);

      const processed = ret.headers.get('x-import-processed');
      const error = ret.headers.get('x-import-error');
      const result = ret.headers.get('x-import-result');
      const message = ret.headers.get('x-import-message');
      const imported = Number(ret.headers.get('x-import-imported'));

      if (result === 'OK') {
        const file = new File([ret.body], `Wynik-Importu-${this.helperService.TimeStamp()}-${action.FileName}`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        if (imported > 0) {
          this.bannerService.instantSuccess(`Zakończono import pliku <b>${action.FileName}</b><br/><b>Zaimportowano ${imported}</b> pozycji.<br/>Przetworzono <b>${processed}</b> wierszy.<br/>Znaleziono <b>${error}</b> wierszy z błędami.`);
        }
        else {
          this.bannerService.instantMessage(`Zakończono import pliku <b>${action.FileName}</b><br/><b>Nie zaimporotwano żadnych pozycji</b>.<br/>Przetworzono <b>${processed}</b> wierszy.<br/>Znaleziono <b>${error}</b> wierszy z błędami.`);
        }

        saveAs(file);
      } else {

        if (message === 'IMPORT_EXCEPTION_EMPTY_FILE') {
          this.bannerService.instantError(`Zakończono import pliku <b>${action.FileName}</b><br/>Plik przeznaczony do importu jest pusty.`);
        } else if (message === 'IMPORT_EXCEPTION_INVALID_FILE_EXTENSION') {
          this.bannerService.instantError(`Zakończono import pliku <b>${action.FileName}</b><br/>Plik przeznaczony do importu ma niewłaściwe rozszerzenie.`);
        } else if (message === 'IMPORT_EXCEPTION_INVALID_HEDER') {
          this.bannerService.instantError(`Zakończono import pliku <b>${action.FileName}</b><br/>Plik przeznaczony do importu ma niewłaściwy nagłówek.`);
        } else {
          this.bannerService.instantError(`Zakończono import pliku <b>${action.FileName}</b><br/>Wystąpił nieznany błąd podczas przetwarzania pliku.`);
        }
      }
    },
      (error) => {

        this.helperService.SaveException('TyreOrderActions.Import', error);

        this.bannerService.error('Błąd importu zleceń zamówień opon.');

        context.dispatch(new TyreOrderActions.SetImportStatus(false));
      },
      () => {
        context.dispatch(new TyreOrderActions.SetImportStatus(false));
      }
    );
  }

  @Action(TyreOrderActions.GetFilteredReport)
  GetFilteredReport(
      context: StateContext<TyreOrderStateModel>,
      action: TyreOrderActions.GetFilteredReport
   ) {
        function patchContext() {
          context.setState(
            patch ({
              FilteredReportLoading: Math.random()
            })
          );
        }

        const fileName = 'Raport-zlecenia-zamówienia-opon';
        this.bannerService.info(`Rozpoczęto generowanie pliku raportu ${fileName}, proszę czekać ...`, 'Export danych');

        this.tyreOrderService.getFilteredReport(action.Search).subscribe (
              res => {
                const file = new File([res], `${fileName}-${this.helperService.TimeStamp()}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(file);
                patchContext();
              },
              res => {
                patchContext();
                this.bannerService.error(`Błąd pobierania raportu: ${fileName}`);
              },
              () => {
                patchContext();
                this.helperService.consoleLog(' @Action(SaleArticleActions.GetFilteredReport)');
              }
          );
  }

  @Action(TyreOrderActions.DisposeSearch)
  DisposeSearch(
      context: StateContext<TyreOrderStateModel>
    ) {

      context.setState(
        patch({
          Search: null
        }));
  }

  @Action(TyreOrderActions.Set)
  Set(
    context: StateContext<TyreOrderStateModel>,
    action: TyreOrderActions.Set
  ) {
    const errorMessage = 'Błąd zapisu zmian zlecenia zamówienia opon.';

    this.tyreOrderService.set(action.Order).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Zapisano zmiany do zlecenia zamówienia opon ' + ret.Item.Number + '.');

          context.setState(
            patch({
              Order: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },

      (error) => {

        this.helperService.SaveException('TyreOrderActions.Set', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreOrderActions.Get)
  Get(
    context: StateContext<TyreOrderStateModel>,
    action: TyreOrderActions.Get
  ) {
    const errorMessage = 'Błąd odczytu szczegółów zlecenia zamówienia opon.';

    this.tyreOrderService.get(action.OrderId).subscribe(
      ret => {

        if (ret.Success) {

          context.setState(
            patch({
              Order: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },

      (error) => {

        this.helperService.SaveException('TyreOrderActions.Get', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreOrderActions.ImportLatexDelivery)
  ImportReRegistration(
    context: StateContext<TyreOrderStateModel>,
    action: TyreOrderActions.ImportLatexDelivery
  ) {

    function patchContext() {
      context.setState(
        patch({
          ImportLatexStatus: Math.random()
        })
      );
    }


    this.bannerService.quickInfo('Rozpoczęto import pliku Latex.');

    this.tyreOrderService.ImportLatexDeliveryFile(action.File).subscribe(ret => {


      const processed = ret.headers.get('x-import-processed');
      const error = ret.headers.get('x-import-error');
      const result = ret.headers.get('x-import-result');
      const message = ret.headers.get('x-import-message');
      const imported = Number(ret.headers.get('x-import-imported'));

      if (result === 'OK') {
        const file = new File([ret.body], `Wynik-Importu-${this.helperService.TimeStamp()}-${action.File.name}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        if (imported > 0) {
          this.bannerService.instantSuccess(`Zakończono import pliku <b>${action.File.name}</b><br/><b>Zaimportowano ${imported}</b> pozycji.<br/>Przetworzono <b>${processed}</b> wierszy.<br/>Znaleziono <b>${error}</b> wierszy z błędami.`);
        }
        else {
          this.bannerService.instantMessage(`Zakończono import pliku <b>${action.File.name}</b><br/><b>Nie zaimporotwano żadnych pozycji</b>.<br/>Przetworzono <b>${processed}</b> wierszy.<br/>Znaleziono <b>${error}</b> wierszy z błędami.`);
        }

        saveAs(file);

      } else {

        if (message === 'IMPORT_EXCEPTION_EMPTY_FILE') {
          this.bannerService.instantError(`Zakończono import pliku <b>${action.File.name}</b><br/>Plik przeznaczony do importu jest pusty.`);
        } else if (message === 'IMPORT_EXCEPTION_INVALID_FILE_EXTENSION') {
          this.bannerService.instantError(`Zakończono import pliku <b>${action.File.name}</b><br/>Plik przeznaczony do importu ma niewłaściwe rozszerzenie.`);
        } else if (message === 'IMPORT_EXCEPTION_INVALID_HEDER') {
          this.bannerService.instantError(`Zakończono import pliku <b>${action.File.name}</b><br/>Plik przeznaczony do importu ma niewłaściwy nagłówek.`);
        } else {
          this.bannerService.instantError(`Zakończono import pliku <b>${action.File.name}</b><br/>Wystąpił nieznany błąd podczas przetwarzania pliku.`);
        }
      }
    },
      (error) => {

        this.helperService.SaveException('TyreOrderActions.ImportLatexDelivery', error);

        this.bannerService.error('Błąd importu pliku Latex.');
      },
      () => {
        patchContext();
      }
    );
  }
}
